"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@angular/core");
const facility_service_1 = require("../../../../services/facility.service");
const dnaR_input_type_enum_1 = require("../../../../../common/components/dnaR-input/enums/dnaR-input-type.enum");
const facility_dto_1 = require("../../../../dtos/facility-dto");
require("underscore");
require("@angular/cdk/keycodes");
const dialog_1 = require("@angular/material/dialog");
require("../../../../../common/components/dnaR-paginator/dnaR-paginator.component");
const tag_dto_1 = require("../../../../../organisation/dtos/tag-dto");
const rxjs_1 = require("rxjs");
const forms_1 = require("@angular/forms");
const dnaRSnackBar_service_1 = require("../../../../../common/dna-r/dnaRSnackBar.service");
const dnaR_action_modal_component_1 = require("../../../../../common/components/dnaR-action-modal/dnaR-action-modal.component");
const core_2 = require("@uirouter/core");
const i0 = require("@angular/core");
const i1 = require("@angular/forms");
const i2 = require("../../../../services/facility.service");
const i3 = require("../../../../../common/dna-r/dnaRSnackBar.service");
const i4 = require("@angular/material/dialog");
const i5 = require("@uirouter/core");
const i6 = require("@angular/material/tooltip");
const i7 = require("@angular/common");
const i8 = require("../../../../../common/components/dnaR-paginator/dnaR-paginator.component");
const i9 = require("../../../../../common/components/dnaR-input/dnaR-input.component");
function LeadTagsEditTabComponent_div_33_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵelementStart(1, "dnaR-input", 32);
    i0.ɵɵlistener("onComponentChange", function LeadTagsEditTabComponent_div_33_div_1_span_2_Template_dnaR_input_onComponentChange_1_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r16 = i0.ɵɵnextContext(2); const formGroup_r1 = ctx_r16.$implicit; const i_r2 = ctx_r16.index; const ctx_r14 = i0.ɵɵnextContext(); return ctx_r14.validateTagNameRequirements($event, formGroup_r1, formGroup_r1.get("name").value.length, i_r2); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("formControl", formGroup_r1.get("name"))("value", formGroup_r1.get("name").value)("required", ctx_r4.submitted)("inputType", ctx_r4.dnaRInputType.text)("duplicate", formGroup_r1.get("isDuplicateInput").value)("tooLong", formGroup_r1.get("isInputTooLong").value)("validate", true);
} }
function LeadTagsEditTabComponent_div_33_div_1_span_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 33);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r1 = i0.ɵɵnextContext(2).$implicit;
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate2(" ", formGroup_r1.get("name").value.length, "/", ctx_r5.maxTagNameLength, " ");
} }
function LeadTagsEditTabComponent_div_33_div_1_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", formGroup_r1.get("name").value, " ");
} }
function LeadTagsEditTabComponent_div_33_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2, " Resident Manager ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} }
function LeadTagsEditTabComponent_div_33_div_1_div_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 34);
} }
function LeadTagsEditTabComponent_div_33_div_1_div_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 35);
    i0.ɵɵelementStart(1, "div", 36);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 37);
    i0.ɵɵelementStart(4, "div");
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div");
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", formGroup_r1.get("userFirstName").value.charAt(0).toUpperCase(), "", formGroup_r1.get("userLastName").value.charAt(0).toUpperCase(), " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" ", formGroup_r1.get("userFirstName").value, " ", formGroup_r1.get("userLastName").value, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(8, 5, formGroup_r1.get("modifiedDate").value, "dd-MMM-yyyy"), " ");
} }
function LeadTagsEditTabComponent_div_33_div_1_div_9_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵlistener("click", function LeadTagsEditTabComponent_div_33_div_1_div_9_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r23); const formGroup_r1 = i0.ɵɵnextContext(2).$implicit; const ctx_r21 = i0.ɵɵnextContext(); return ctx_r21.onClickHide(formGroup_r1); });
    i0.ɵɵelementStart(1, "div", 39);
    i0.ɵɵelement(2, "input", 40);
    i0.ɵɵelement(3, "div", 41);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r1 = i0.ɵɵnextContext(2).$implicit;
    i0.ɵɵproperty("matTooltip", formGroup_r1.get("isHidden").value == true ? "Unhide" : "Hide");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("checked", formGroup_r1.get("isHidden").value);
} }
function LeadTagsEditTabComponent_div_33_div_1_div_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "div", 16);
} }
function LeadTagsEditTabComponent_div_33_div_1_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r27 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 42);
    i0.ɵɵlistener("click", function LeadTagsEditTabComponent_div_33_div_1_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r27); const ctx_r26 = i0.ɵɵnextContext(2); const formGroup_r1 = ctx_r26.$implicit; const i_r2 = ctx_r26.index; const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.removeClick(formGroup_r1, i_r2); });
    i0.ɵɵelement(1, "span", 43);
    i0.ɵɵelementEnd();
} }
function LeadTagsEditTabComponent_div_33_div_1_a_13_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 44);
    i0.ɵɵelement(1, "span", 45);
    i0.ɵɵelementEnd();
} }
function LeadTagsEditTabComponent_div_33_div_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "div", 13);
    i0.ɵɵtemplate(2, LeadTagsEditTabComponent_div_33_div_1_span_2_Template, 2, 7, "span", 24);
    i0.ɵɵtemplate(3, LeadTagsEditTabComponent_div_33_div_1_span_3_Template, 2, 2, "span", 25);
    i0.ɵɵtemplate(4, LeadTagsEditTabComponent_div_33_div_1_span_4_Template, 2, 1, "span", 24);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "div", 15);
    i0.ɵɵtemplate(6, LeadTagsEditTabComponent_div_33_div_1_div_6_Template, 3, 0, "div", 24);
    i0.ɵɵtemplate(7, LeadTagsEditTabComponent_div_33_div_1_div_7_Template, 1, 0, "div", 26);
    i0.ɵɵtemplate(8, LeadTagsEditTabComponent_div_33_div_1_div_8_Template, 9, 8, "div", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, LeadTagsEditTabComponent_div_33_div_1_div_9_Template, 4, 2, "div", 28);
    i0.ɵɵtemplate(10, LeadTagsEditTabComponent_div_33_div_1_div_10_Template, 1, 0, "div", 29);
    i0.ɵɵelementStart(11, "div", 18);
    i0.ɵɵtemplate(12, LeadTagsEditTabComponent_div_33_div_1_a_12_Template, 2, 0, "a", 30);
    i0.ɵɵtemplate(13, LeadTagsEditTabComponent_div_33_div_1_a_13_Template, 2, 0, "a", 31);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r1 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == false);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == true && formGroup_r1.get("userFirstName").value === null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == true && formGroup_r1.get("userFirstName").value != null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == false);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == true && formGroup_r1.get("canDelete").value == true);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isCustom").value == true && formGroup_r1.get("canDelete").value == false);
} }
function LeadTagsEditTabComponent_div_33_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, LeadTagsEditTabComponent_div_33_div_1_Template, 14, 10, "div", 22);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const formGroup_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    i0.ɵɵproperty("formGroup", formGroup_r1);
    i0.ɵɵattribute("data-index", i_r2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", formGroup_r1.get("isDeleted").value != true);
} }
/**
 * Displays the lead tags edit tab.
 */
class LeadTagsEditTabComponent {
    /**
     * Initializes a new instance of the FacilityDetailsTabComponent class.
     *
     * @param facilityService The facility service.
     * @param fundingService The funding service.
     * @param snackBarService The SnackBar service.
     * @param dialog The material design dialog.
     */
    constructor(formBuilder, facilityService, snackBarService, dialog, uiRouter) {
        this.formBuilder = formBuilder;
        this.facilityService = facilityService;
        this.snackBarService = snackBarService;
        this.dialog = dialog;
        this.uiRouter = uiRouter;
        this.isDirty = false;
        this.submitted = false;
        this.editTagsForm = this.formBuilder.group({
            formLeadTags: this.formBuilder.array([])
        });
        /**
         * Event emitted when the user finishes editting.
         */
        this.onDone = new core_1.EventEmitter();
        this.maxTagNameLength = 20;
        /**
         * The tags to display in the filter drop down.
         */
        this.tags$ = new rxjs_1.BehaviorSubject(null);
        /**
         * The card pagination page index.
         */
        this.pageIndex = 0;
        /**
         * The card pagination page size.
         */
        this.pageSize = 25;
        /**
         * The card pagination page size options
         */
        this.pageSizeOptions = [25, 50, 75, 100, 'All'];
        /**
         * The total number of tags
         */
        this.totalNumberOfTags = 0;
        /**
         * If true then the filter drawer is open are shown, otherwise filter drawer is close and hidden.
         */
        this.filterDrawerOpen = false;
        this.dnaRInputType = dnaR_input_type_enum_1.DnaRInputType;
        this.saveForm = function (isValid) {
            let customTags = this.formLeadTags.controls.filter(x => x.value.isCustom == true).map(x => x.value);
            if (isValid) {
                this.facilityService.saveTags(customTags)
                    .then(result => {
                    this.snackBarService.success("Lead tags saved");
                    this.doneEditting(false);
                }, () => {
                    this.snackBarService.failure("Unexpected error while saving the lead tags");
                });
            }
        };
    }
    get formLeadTags() {
        return this.editTagsForm.controls["formLeadTags"];
    }
    set facility(value) {
        this._facility = value;
    }
    get facility() {
        return this._facility;
    }
    set tags(value) {
        this._tags = value;
    }
    get tags() {
        return this._tags;
    }
    // @HostListener allows us to also guard against browser refresh, close, etc.
    //Reference (22/03/2024): https://stackoverflow.com/questions/35922071/warn-user-of-unsaved-changes-before-leaving-page
    canDeactivate() {
        // returning true will navigate without confirmation
        // returning false will show a confirm dialog before navigating away
        return !this.isDirty;
    }
    ngOnDestroy() {
        if (this.hookReturnFn) {
            this.hookReturnFn();
        }
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    /**
     * @inheritdoc
     */
    ngOnInit() {
        let savedThis = this;
        this.hookReturnFn = this.uiRouter.transitionService.onBefore({}, function (transition) {
            return __awaiter(this, void 0, void 0, function* () {
                return yield savedThis.cancel(true);
            });
        });
        this.loadTags();
    }
    loadTags() {
        let skip = null;
        let take = null;
        // Calculate pagination values only if isn't a number (ie 'All')
        if (!isNaN(this.pageSize)) {
            skip = this.pageSize * this.pageIndex;
            take = Number(this.pageSize);
        }
        this.facilityService.getAllTagsForFacilityId(this.facility.id, skip, take).then((result) => {
            this.totalNumberOfTags = result.totalCount;
            this.tags$.next(result.result);
            this.subscription = this.tags$.subscribe(x => this.tags = x);
            this.tags.forEach(((tag, index) => {
                this.addNewFormGroup(index, tag);
            }));
        }, () => {
            this.snackBarService.failure("Unexpected error while loading tags");
        });
    }
    /**
     * Add a new custom tag.
     *
     */
    addCustomTag() {
        const newTag = new tag_dto_1.TagDto();
        newTag.id = 0;
        newTag.name = "";
        newTag.isCustom = true;
        newTag.isDeleted = false;
        newTag.isHidden = false;
        newTag.canDelete = true;
        newTag.facilityId = this.facility.id;
        this.addNewFormGroup(0, newTag);
    }
    addNewFormGroup(atIndex, tag) {
        const formGroup = this.formBuilder.group({
            id: [tag.id],
            name: [(tag.name != undefined) ? tag.name : null, forms_1.Validators.required],
            isCustom: [tag.isCustom],
            isDeleted: [tag.isDeleted],
            isHidden: [tag.isHidden],
            canDelete: [tag.canDelete],
            facilityId: this.facility.id,
            modifiedDate: [tag.modifiedDate],
            userFirstName: [tag.userFirstName],
            userLastName: [tag.userLastName],
            isDuplicateInput: [false],
            isInputTooLong: [false]
        });
        this.formLeadTags.insert(atIndex, formGroup);
    }
    validateTagNameRequirements(event, updatedRow, tagNameLength, indexUpdated) {
        if (updatedRow.touched) {
            this.isDirty = true;
        }
        var updatedTagName = updatedRow.get('name');
        var updatedTagNameValue = updatedTagName.value;
        updatedRow.get('isInputTooLong').setValue(false); //  clear updated error
        updatedRow.get('isDuplicateInput').setValue(false); //  clear updated error
        if (updatedTagNameValue != undefined) {
            if (tagNameLength > this.maxTagNameLength) {
                updatedTagName.setErrors({ 'tooLong': true });
                updatedRow.get('isInputTooLong').setValue(true);
            }
            this.formLeadTags.controls.forEach((otherRow, index) => {
                var otherRowTagName = otherRow.get('name');
                var otherTagNameValue = otherRowTagName.value;
                if (indexUpdated != index && otherTagNameValue == updatedTagNameValue) {
                    updatedTagName.setErrors({ 'duplicate': true });
                    updatedRow.get('isDuplicateInput').setValue(true);
                    return;
                }
            });
        }
    }
    submit() {
        this.submitted = true;
        (setTimeout(_ => {
            // to assure form recalculate it's status
            this.editTagsForm.updateValueAndValidity();
            if (this.editTagsForm.status === 'VALID') {
                this.saveForm(true);
            }
        }));
    }
    cancel(navigatingOut) {
        return __awaiter(this, void 0, void 0, function* () {
            let result = new Promise((resolve, reject) => {
                if (this.isDirty) {
                    let text = "Are you sure you want to leave the current page?\n The changes made won't be saved.";
                    var dialogData = {
                        title: "Leave page",
                        text: text,
                        action: "Leave",
                        actionButtonClass: "btn-primary",
                        actionFunction: () => {
                            navigatingOut ? undefined : this.doneEditting(true);
                            resolve();
                        }
                    };
                    this.dialog.open(dnaR_action_modal_component_1.DnaRActionModalComponent, {
                        panelClass: 'custom-dialog-container',
                        width: '456px',
                        height: '250px',
                        data: dialogData
                    });
                }
                else {
                    this.doneEditting(true);
                    resolve();
                }
            });
            return result;
        });
    }
    removeClick(formGroup, index) {
        if (formGroup != null) {
            let dialogData = {
                title: "Delete tag",
                text: "Are you sure you want to delete this tag?",
                action: "Delete",
                actionButtonClass: "btn-primary",
                actionFunction: () => {
                    this.markDeleted(formGroup, index);
                }
            };
            this.dialog.open(dnaR_action_modal_component_1.DnaRActionModalComponent, {
                panelClass: 'custom-dialog-container',
                width: '456px',
                height: 'hug',
                data: dialogData
            });
        }
    }
    markDeleted(formGroup, index) {
        formGroup.markAsTouched();
        formGroup.get("isDeleted").setValue(true);
        this.isDirty = true;
        if (Number(formGroup.get("id").value) == 0) {
            this.formLeadTags.controls.splice(this.formLeadTags.controls.indexOf(formGroup), 1);
        }
    }
    onClickHide(formGroup) {
        let isHidden = formGroup.get("isHidden").value;
        formGroup.patchValue({ isHidden: !isHidden });
        this.isDirty = true;
    }
    /**
     * Emits the @see onDone event.
     *
     * @param cancelled true if the user cancelled editting, otherwise false.
     */
    doneEditting(cancelled) {
        this.onDone.emit(cancelled);
    }
    /**
     * Handing the page event
     *
     * @param e The page event parameters.
     */
    handlePageEvent(e) {
        this.totalNumberOfTags = e.length;
        this.pageSize = e.pageSize;
        this.pageIndex = e.pageIndex;
        this.loadTags();
    }
    /**
     * Opens the filter drawer.
     */
    openFilterDrawer() {
        this.filterDrawerOpen = true;
    }
    /**
     * Closes the filter drawer.
     */
    closeFilterDrawer() {
        this.filterDrawerOpen = false;
    }
}
exports.LeadTagsEditTabComponent = LeadTagsEditTabComponent;
LeadTagsEditTabComponent.ɵfac = function LeadTagsEditTabComponent_Factory(t) { return new (t || LeadTagsEditTabComponent)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.FacilityService), i0.ɵɵdirectiveInject(i3.DnaRSnackBarService), i0.ɵɵdirectiveInject(i4.MatDialog), i0.ɵɵdirectiveInject(i5.UIRouter)); };
LeadTagsEditTabComponent.ɵcmp = i0.ɵɵdefineComponent({ type: LeadTagsEditTabComponent, selectors: [["lead-tags-edit-tab"]], hostBindings: function LeadTagsEditTabComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("beforeunload", function LeadTagsEditTabComponent_beforeunload_HostBindingHandler($event) { return ctx.canDeactivate($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { facility: "facility", tags: "tags" }, outputs: { onDone: "onDone" }, decls: 36, vars: 8, consts: [[1, "lead-tags-tab"], [1, "panel-body"], [1, "row", "space-below-header"], [1, "col-xs-5", "page-header"], [1, "button-group", "pull-right", "page-header"], ["data-automation", "cancel-button", 1, "btn", "btn-warning", "btn-inline-block", "cancel-button", 3, "click"], ["type", "submit", "data-automation", "save-button", 1, "btn", "btn-primary", "btn-inline-block", "save-button", 3, "click"], [1, "row", "space-below-label"], [1, "col-xs-2", "btn", "add-new-item-button", "pull-right", 3, "click"], [1, "icon", "icon-primary-t2", "icon-add-circle-fill"], [3, "formGroup"], [1, "row", "space-below-label", "tags-list"], [1, "col-xs-12", "noSidePadding", "list-header"], [1, "column", "tag-column"], [1, "required"], [1, "column", "updated-column"], [1, "column", "hide-column"], ["matTooltip", "Remove tag option from pre-admission list", 1, "dna-info-icon", 3, "matTooltipPosition"], [1, "column", "delete-column"], ["formArrayName", "formLeadTags", 1, "col-xs-12", "noSidePadding", "list-items"], [3, "formGroup", 4, "ngFor", "ngForOf"], [3, "length", "pageSize", "pageSizeOptions", "pageIndex", "itemsDisplayLabel", "page"], ["class", "col-xs-12 noSidePadding item", 4, "ngIf"], [1, "col-xs-12", "noSidePadding", "item"], [4, "ngIf"], ["class", "pull-right", 4, "ngIf"], ["class", "new-tag", 4, "ngIf"], ["class", "user-info", 4, "ngIf"], ["class", "column hide-column new-tag", "matTooltipClass", "mat-tooltip", 3, "matTooltip", "click", 4, "ngIf"], ["class", "column hide-column", 4, "ngIf"], ["class", "delete-link", "matTooltip", "Delete", "matTooltipClass", "mat-tooltip", "class.disabled", "false", 3, "click", 4, "ngIf"], ["class", "delete-link", "matTooltip", "Tag in use and cannot be deleted", "matTooltipClass", "mat-tooltip", "class.disabled", "true", "disabled", "", 4, "ngIf"], ["name", "name", "formControlName", "name", "prefix", "", "requiredError", "Tag name required", "duplicateInputError", "Tag name must be unique", "tooLongError", "Must not exceed 20 characters", 3, "formControl", "value", "required", "inputType", "duplicate", "tooLong", "validate", "onComponentChange"], [1, "pull-right"], [1, "new-tag"], [1, "user-info"], [1, "user-initials"], [1, "user-name-and-date"], ["matTooltipClass", "mat-tooltip", 1, "column", "hide-column", "new-tag", 3, "matTooltip", "click"], [1, "checkbox-edit"], ["name", "hide", "type", "checkbox", 3, "checked"], ["id", "itemText"], ["matTooltip", "Delete", "matTooltipClass", "mat-tooltip", "class.disabled", "false", 1, "delete-link", 3, "click"], [1, "icon", "icon-delete-fill"], ["matTooltip", "Tag in use and cannot be deleted", "matTooltipClass", "mat-tooltip", "class.disabled", "true", "disabled", "", 1, "delete-link"], [1, "icon", "icon-delete-fill", "link-disabled"]], template: function LeadTagsEditTabComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "h2", 3);
        i0.ɵɵtext(4, "Lead tags");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 4);
        i0.ɵɵelementStart(6, "span");
        i0.ɵɵelementStart(7, "a", 5);
        i0.ɵɵlistener("click", function LeadTagsEditTabComponent_Template_a_click_7_listener() { return ctx.cancel(false); });
        i0.ɵɵtext(8, "Cancel");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "span");
        i0.ɵɵelementStart(10, "button", 6);
        i0.ɵɵlistener("click", function LeadTagsEditTabComponent_Template_button_click_10_listener() { return ctx.submit(); });
        i0.ɵɵtext(11, "Save");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 7);
        i0.ɵɵelementStart(13, "button", 8);
        i0.ɵɵlistener("click", function LeadTagsEditTabComponent_Template_button_click_13_listener() { return ctx.addCustomTag(); });
        i0.ɵɵelement(14, "span", 9);
        i0.ɵɵelementStart(15, "span");
        i0.ɵɵtext(16, "New tag");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "form", 10);
        i0.ɵɵelementStart(18, "div", 11);
        i0.ɵɵelementStart(19, "div", 12);
        i0.ɵɵelementStart(20, "div", 13);
        i0.ɵɵelementStart(21, "span", 14);
        i0.ɵɵtext(22, "*");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(23, "span");
        i0.ɵɵtext(24, " Tag");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 15);
        i0.ɵɵelementStart(26, "span");
        i0.ɵɵtext(27, " Updated ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(28, "div", 16);
        i0.ɵɵtext(29, " Hide ");
        i0.ɵɵelement(30, "span", 17);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(31, "div", 18);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 19);
        i0.ɵɵtemplate(33, LeadTagsEditTabComponent_div_33_Template, 2, 3, "div", 20);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "div");
        i0.ɵɵelementStart(35, "dnaR-paginator", 21);
        i0.ɵɵlistener("page", function LeadTagsEditTabComponent_Template_dnaR_paginator_page_35_listener($event) { return ctx.handlePageEvent($event); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(17);
        i0.ɵɵproperty("formGroup", ctx.editTagsForm);
        i0.ɵɵadvance(13);
        i0.ɵɵproperty("matTooltipPosition", "after");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngForOf", ctx.formLeadTags.controls);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("length", ctx.totalNumberOfTags)("pageSize", ctx.pageSize)("pageSizeOptions", ctx.pageSizeOptions)("pageIndex", ctx.pageIndex)("itemsDisplayLabel", "Rows");
    } }, directives: [i1.ɵangular_packages_forms_forms_y, i1.NgControlStatusGroup, i1.FormGroupDirective, i6.MatTooltip, i1.FormArrayName, i7.NgForOf, i8.DnaRPaginator, i7.NgIf, i9.DnaRInput, i1.NgControlStatus, i1.FormControlName, i1.FormControlDirective, i1.RequiredValidator], pipes: [i7.DatePipe], styles: [".cancel-button[_ngcontent-%COMP%] {\n  margin-right: 4px;\n}\n.save-button[_ngcontent-%COMP%] {\n  margin-left: 4px;\n}\n.button-group[_ngcontent-%COMP%] {\n  margin: 20px 0px;\n}\n.tag-header[_ngcontent-%COMP%] {\n  display: inline-block;\n  padding-bottom: 6px;\n}\n.add-new-item-button[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n  color: #008381;\n  padding: 1px 3px;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  border-radius: 2px;\n}\n.add-new-item-button[_ngcontent-%COMP%]:hover {\n  Color: #025450;\n  text-decoration: underline;\n}\n.list-header[_ngcontent-%COMP%] {\n  border-bottom: 1px solid #D2D2D2;\n  font-weight: bold;\n  height: 56px;\n  display: inline-block;\n  font-style: normal;\n  font-weight: 600;\n  letter-spacing: 0;\n  color: #595959;\n  line-height: 56px;\n  vertical-align: middle;\n}\n.tags-list[_ngcontent-%COMP%] {\n  display: block;\n  background-color: #ffffff;\n  border-top: 2px solid #D2D2D2;\n}\n.tags-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%] {\n  background-color: #ffffff;\n  display: block;\n  border-bottom: 2px;\n}\n.tags-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .item[_ngcontent-%COMP%] {\n  display: relative;\n  border-top: 1px solid #D2D2D2;\n  height: auto;\n  min-height: 40px;\n  padding: 8px 0 0 0;\n}\n.tags-list[_ngcontent-%COMP%]   .list-items[_ngcontent-%COMP%]   .delete-link[_ngcontent-%COMP%] {\n  height: 24px;\n  width: 24px;\n  padding: 0;\n  margin: 10px 0 0 0;\n  display: inline-block;\n}\n.link-disabled[_ngcontent-%COMP%] {\n  background: #D2D2D2;\n}\n.column[_ngcontent-%COMP%] {\n  display: inline-block;\n  float: left;\n  margin: 0 16px;\n  font-size: 16px;\n}\n.column.tag-column[_ngcontent-%COMP%] {\n  width: 270px;\n  padding-right: 16px;\n  margin: 0px 0px 0px 16px;\n}\n.column.updated-column[_ngcontent-%COMP%] {\n  padding: 0px 16px;\n  min-width: 270px !important;\n  margin: 0px;\n}\n.column.updated-column[_ngcontent-%COMP%]   .new-tag[_ngcontent-%COMP%] {\n  height: 54px !important;\n}\n.column.hide-column[_ngcontent-%COMP%] {\n  width: 90px;\n  margin: 0px;\n  vertical-align: middle;\n}\n.column.hide-column.new-tag[_ngcontent-%COMP%] {\n  padding: 8px 0px 0px 16px;\n}\n.column.delete-column[_ngcontent-%COMP%] {\n  width: 24px;\n  margin: 0px;\n}\n.user-info[_ngcontent-%COMP%] {\n  display: flex;\n}\n.user-info[_ngcontent-%COMP%]   .user-initials[_ngcontent-%COMP%] {\n  display: block;\n  font-size: 16px;\n  font-weight: 600;\n  height: 32px;\n  width: 32px;\n  background-color: #D2D2D2;\n  color: #000000;\n  text-align: center;\n  line-height: 24px;\n  margin-top: 8px;\n  margin-right: 8px;\n  padding-top: 4px;\n  float: left;\n}\n.user-info[_ngcontent-%COMP%]   .user-name-and-date[_ngcontent-%COMP%] {\n  text-overflow: ellipsis;\n  display: block;\n  float: right;\n  width: auto;\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%] {\n  z-index: 9999;\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:focus    + div[_ngcontent-%COMP%]:before, .new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:hover    + div[_ngcontent-%COMP%]:before {\n  border-color: #337ab7;\n  box-shadow: 2px;\n  background-color: #f2f2f2;\n}\nnew-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:active    + div[_ngcontent-%COMP%]:before {\n  transition-duration: 0s;\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%] {\n  position: relative;\n  padding-left: 2em;\n  vertical-align: middle;\n  user-select: none;\n  cursor: pointer;\n  margin: 0px;\n  font-size: 16px;\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%]:before {\n  box-sizing: content-box;\n  content: '';\n  color: #008381;\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 14px;\n  height: 14px;\n  margin-top: -9px;\n  border: 2px solid #949494;\n  border-radius: 2px;\n  text-align: center;\n  transition: all 0.4s ease;\n  background-color: #fff;\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%]:after {\n  box-sizing: content-box;\n  content: '';\n  background-color: #008381;\n  position: absolute;\n  left: 4px;\n  width: 9px;\n  height: 4px;\n  margin-top: -3px;\n  transform: scale(0);\n  transform-origin: 50%;\n  transition: transform 200ms ease-out;\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]    + div[_ngcontent-%COMP%]:after {\n  background-color: transparent;\n  top: 50%;\n  left: 4px;\n  width: 9px;\n  height: 4px;\n  margin-top: -5px;\n  border-style: solid;\n  border-color: #008381;\n  border-width: 0 0 2px 2px;\n  border-image: none;\n  transform: rotate(-45deg) scale(0);\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:after {\n  content: '';\n  border-color: #fff;\n  transform: rotate(-45deg) scale(1);\n  transition: transform 200ms ease-out;\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:before {\n  animation: borderscale 200ms ease-in;\n  background-color: #008381;\n  border-color: #008381;\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + div[_ngcontent-%COMP%]:after {\n  transform: rotate(-45deg) scale(1);\n}\n.new-tag[_ngcontent-%COMP%]   input[type='checkbox'][_ngcontent-%COMP%]:checked    + #itemText[_ngcontent-%COMP%] {\n  color: #008381;\n  font-weight: 600;\n}\n.page-header[_ngcontent-%COMP%] {\n  margin-top: 0px;\n  padding-left: 0px;\n}\n.space-below-header[_ngcontent-%COMP%] {\n  padding-left: 0px;\n}\n.pagination[_ngcontent-%COMP%] {\n  border-bottom: 2px;\n}\n.checkbox-edit[_ngcontent-%COMP%] {\n  display: flex;\n  padding-left: 8px;\n  background-color: #ffffff;\n  width: 32px !important;\n  height: 32px !important;\n}\n.checkbox-edit[_ngcontent-%COMP%]:hover, .checkbox-edit[_ngcontent-%COMP%]:focus {\n  background-color: #EBF5F5;\n  padding-left: 8px !important;\n  border-radius: 50%;\n}"] });
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LeadTagsEditTabComponent, [{
        type: core_1.Component,
        args: [{
                selector: 'lead-tags-edit-tab',
                styleUrls: ['./lead-tags-edit-tab.component.less'],
                templateUrl: './lead-tags-edit-tab.component.html'
            }]
    }], function () { return [{ type: i1.FormBuilder }, { type: i2.FacilityService }, { type: i3.DnaRSnackBarService }, { type: i4.MatDialog }, { type: i5.UIRouter }]; }, { facility: [{
            type: core_1.Input
        }], tags: [{
            type: core_1.Input
        }], onDone: [{
            type: core_1.Output
        }], canDeactivate: [{
            type: core_1.HostListener,
            args: ['window:beforeunload', ['$event']]
        }] }); })();
